// extracted by mini-css-extract-plugin
export default {"container":"Container-module__container___j9do0"};